import ContentCopy from "@material-symbols/svg-500/rounded/content_copy.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ContentCopyIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: ContentCopy });
	return <Icon />;
};

export default memo(ContentCopyIcon);
